// extracted by mini-css-extract-plugin
export default {"text":"Labels_text__flVuB"};